<div class="jumbotron text-center">
    <h1 class="display-3" style="margin-top: 50px">Thank You!</h1>
    <p class="lead" style="margin-top: 30px">{{ strTitle }}</p>
    <div *ngIf="strButton != ''">
      <a [href]="strLink" class="btn btn-success btn-lg mt-2" target="_blank">{{ strButton }}</a>
    </div> 
    <p class="lead" style="margin-top: 30px" *ngIf="strLicense != ''">Your RegScale License key is: <br/><br/><strong>{{ strLicense }}</strong></p>
    <hr>
    <p style="margin-bottom: 30px; margin-top: 25px;">
      Have an urgent request and need to talk now? <a href="tel:202-991-7881">Contact us via phone at 202-991-7881</a>
    </p>
    <p class="lead">
      <a class="btn btn-primary btn-sm" [routerLink]="['/home']" role="button">Return to Homepage</a>
    </p>
  </div>
